/**
 * The pages someone opened in this tab, newest first: the 404's "Pages you opened
 * recently" row and the global search's "Recent" list (spec 4.11, §5 Global search).
 * sessionStorage, so it ends with the tab and never leaves the browser; every read and
 * write is guarded, because storage can be blocked or full.
 */
export interface RecentPage {
  path: string;
  title: string;
}

const KEY = 'grow.recentPages';
const MAX = 8;

export function readRecentPages(): RecentPage[] {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list)
      ? list.filter((p) => p && typeof p.path === 'string' && typeof p.title === 'string')
      : [];
  } catch {
    return [];
  }
}

export function recordRecentPage(page: RecentPage) {
  if (!page.path || !page.title) return;
  try {
    const rest = readRecentPages().filter((p) => p.path !== page.path && p.title !== page.title);
    window.sessionStorage.setItem(KEY, JSON.stringify([page, ...rest].slice(0, MAX)));
  } catch {
    // Storage blocked or full: the lists are a convenience, so they just stay empty.
  }
}
